import React, {useCallback} from 'react';

import {ContextualButtonLink} from 'src/components/contextual-link/contextual-button-link';
import {ChangeRequestContextualLink} from 'src/openapi/models/ChangeRequestContextualLink';

type Props = {
    contextualLink: ChangeRequestContextualLink,
};

export const ContextualLink = ({contextualLink}: Props) => {

    const onClick = useCallback(() => {
        window.open(contextualLink.value);
    }, [contextualLink.value]);

    return (
        <ContextualButtonLink
            contextualLink={contextualLink}
            onClick={onClick}
        />
    );
};
